import axios from "./axiosInstance";

const WeekendTripsAPI = {
  getweekendTrips: () => axios.get(`/weekendtrips`),
};

export default WeekendTripsAPI;